import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { MeshBasicMaterial, MeshStandardMaterial } from "three";

export function RoomBaked(props) {
  // const { nodes, materials } = useGLTF("/room_bakedFinal_min.glb");
  const { nodes, materials } = useGLTF("/final.glb");
  let glassParameters = {
    transparent: true,
    metalness: 0,
    roughness: 0,
    opacity: 0.5
  }

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Cristal_tejado.geometry} position={[0.08, 0.09, -0.03]}
        material={new MeshStandardMaterial(glassParameters)}/>
      <mesh geometry={nodes.CristalBarandilla.geometry} position={[0.08, 0.09, -0.03]} 
        material={new MeshStandardMaterial(glassParameters)}/>

      {/* <group position={[-2.92, 1.43, -0.69]}>
        <mesh
          geometry={nodes.TBC100.geometry}
          material={materials["Material.002"]}
        />
        <mesh
          geometry={nodes.TBC100_1.geometry}
          material={materials.checker_material_2048x2048}
        />
        <mesh
          geometry={nodes.TBC100_2.geometry}
          material={materials["Material.013"]}
        />
        <mesh geometry={nodes.TBC100_3.geometry} material={materials.Tapon} />
        <mesh
          geometry={nodes.TBC100_4.geometry}
          material={materials.CuerpoBotella}
        />
        <mesh
          geometry={nodes.TBC100_5.geometry}
          material={materials["Material.003"]}
        />
        <mesh
          geometry={nodes.TBC100_6.geometry}
          material={materials["Material.004"]}
        />
        <mesh
          geometry={nodes.TBC100_7.geometry}
          material={materials["Material.005"]}
        />
        <mesh
          geometry={nodes.TBC100_8.geometry}
          material={materials["Material.006"]}
        />
        <mesh
          geometry={nodes.TBC100_9.geometry}
          material={materials["Material.007"]}
        />
        <mesh
          geometry={nodes.TBC100_10.geometry}
          material={materials["Material.008"]}
        />
        <mesh
          geometry={nodes.TBC100_11.geometry}
          material={materials["Material.009"]}
        />
        <mesh
          geometry={nodes.TBC100_12.geometry}
          material={materials["Material.010"]}
        />
        <mesh
          geometry={nodes.TBC100_13.geometry}
          material={materials["Default OBJ.002"]}
        />
        <mesh
          geometry={nodes.TBC100_14.geometry}
          material={materials["Material.011"]}
        /> 
      </group> */}
      <mesh
        geometry={nodes.Paredes.geometry}
        material={materials["Material.001"]}
        // material={new MeshBasicMaterial({map: materials["Material.001"].map})}
        position={[0.08, 0.09, -0.03]}
      />
      <mesh
        geometry={nodes.Muebles.geometry}
        material={materials.Checker}
        position={[1.28, 0.11, 3.51]}
        rotation={[0, -1.57, 0]}
      />
    </group>
  );
}

useGLTF.preload("/final.glb");
